import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function GrowthGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'personal-development' });
  const activities = useNamedSelector('clarity.activities', { category: 'personal-development' });
  return (
    <List tiny-gutter>
      <p>Where in your life would you like to grow and develop? Make this your personal development goal.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>Looking at your goal, what are one or two concrete things you can do to make it happen. Schedule and commit to it.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
